import { clamp } from "../lib/utils";

export const TOOLS_MIN_WIDTH = 320;
export const TOOLS_DEFAULT_WIDTH = 360;
export const TOOLS_MAX_VIEWPORT_RATIO = 0.5;

export const toolsWidthStorageKey = (userId: string) => `admin-tools-width:${userId}`;

export const toolsMaxWidth = (viewportWidth: number) =>
	Math.max(TOOLS_MIN_WIDTH, Math.floor(viewportWidth * TOOLS_MAX_VIEWPORT_RATIO));

export const clampToolsWidth = (width: number, viewportWidth: number) =>
	clamp(width, TOOLS_MIN_WIDTH, toolsMaxWidth(viewportWidth));
